import { translationHistory } from "./TranslationHistory.slice";

export const translationHistoryActions = { ...translationHistory.actions };
